export default {
  buttons: {
    prev: "Previous",
    next: "Next",
    finish: "Finish",
    close: "✕",
  },
};

